/**
 * WorkspaceInviteService.js
 *
 * Service for workspace invite lifecycle actions via Cloud Functions.
 */

import { functions, httpsCallable } from 'firebaseConfig';

const callable = (name) => httpsCallable(functions, name);

export async function createWorkspaceInvites({ workspaceKey, invites = [], role = 'member', message = '' }) {
  if (!workspaceKey || !Array.isArray(invites) || invites.length === 0) {
    throw new Error('workspaceKey and at least one invite are required');
  }

  const fn = callable('createWorkspaceInvites');
  const { data } = await fn({ workspaceKey, invites, role, message });
  return data || null;
}

export async function revokeWorkspaceInvite({ workspaceKey, inviteKey }) {
  if (!workspaceKey || !inviteKey) {
    throw new Error('workspaceKey and inviteKey are required');
  }

  const fn = callable('revokeWorkspaceInvite');
  const { data } = await fn({ workspaceKey, inviteKey });
  return data || null;
}

export async function listWorkspaceInvites({ workspaceKey }) {
  if (!workspaceKey) {
    throw new Error('workspaceKey is required');
  }

  const fn = callable('listWorkspaceInvites');
  const { data } = await fn({ workspaceKey });
  return Array.isArray(data?.invites) ? data.invites : [];
}

export async function acceptWorkspaceInvite({ token }) {
  if (!token) {
    throw new Error('token is required');
  }

  const fn = callable('acceptWorkspaceInvite');
  const { data } = await fn({ token });
  return data || null;
}
